import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { HbNotification } from '../../notifications/notification';
import { NotificationLife } from '../../notifications/notification-life';
import { NotificationState } from '../../notifications/notification-state';
import { NotificationService } from '../../notifications/notification.service';

@Injectable({
  providedIn: 'root',
})
export class HierarchyTemplatesNotificationService {

  public constructor(
    private i18NextPipe: I18NextPipe,
    private notificationService: NotificationService,
  ) { }

  public showCompletedNotification(): void {
    this.showNotification(this.i18NextPipe.transform('HierarchyTemplate.DeleteSuccessMessage'), NotificationState.Complete);
  }

  public showFailedNotification(errorMessage: string): void {
    this.showNotification(errorMessage, NotificationState.Failed);
  }

  public showNotification(description: string, state: NotificationState): void {
    const notification = new HbNotification();

    notification.description = description;
    notification.state = state;
    notification.life = NotificationLife.Long;
    this.notificationService.displayToast(notification);
  }
}
